<template>
  <div
    class="pane content-detail scrollY-auto"
    ref="box3"
    id="box3"
    :class="[isToggle3, detailWrap]"
  >
    <div class="ly-detail">
      <div class="ly-detail-top">
        <div class="ly-title">
          <h3 class="title-sub">수신그룹 상세정보</h3>
          <div class="ly-btn">
            <el-button
              class="btn-toggle"
              :class="detailViewClass"
              @click="expandDetailView"
            ></el-button>
          </div>
        </div>
      </div>
      <div class="ly-detail-wrap">
        <template v-if="isShowDetail">
          <div class="ly-detail-content">
            <div class="tab-block">
              <div class="tab-body">
                <el-form ref="form" label-width="90px" :model="formDataMsngTmpltRcvGroup">
                  <el-row class="ly-el-row">
                    <el-col :span="16">
                      <el-form-item label="수신그룹명" label-width="90px">
                        <idc-input
                          v-model="formDataMsngTmpltRcvGroup.tmpltNm"
                          size="medium"
                          :placeholder="$t('messages.plInput')"
                          :disabled="selectPopup"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="그룹 유형">
                        <idc-input
                          disabled
                          size="medium"
                          v-model="formDataMsngTmpltRcvGroup.msngRcvCtgNm"
                          :placeholder="$t('messages.plSelect')"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="ly-el-row">
                    <el-col :span="8">
                      <el-form-item :label="$t('messages.lblUseStatus')">
                        <el-select
                          size="medium"
                          v-model="formDataMsngTmpltRcvGroup.useYn"
                          :placeholder="$t('messages.plSelect')"
                          :disabled="selectPopup"

                        >
                          <el-option
                            v-for="item in options3"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('messages.lblRegister')">
                        <idc-input
                          disabled
                          v-model="userNm"
                          class="input-id"
                          size="medium"
                          placeholder="자동입력"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('messages.lblRegistDateTime')"
                      >
                        <idc-input
                          disabled
                          v-model="formDataMsngTmpltRcvGroup.regDt"
                          class="input-id"
                          size="medium"
                          placeholder="자동입력"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="ly-el-row">
                    <div class="ly-title">
                      <h3 class="title-table">
                        수신자 리스트
                      </h3>
                      <div class="ly-sort ly-sort-his">
                        <div>
                          <el-button
                            plain
                            size="small"
                            type="primary"
                            @click="openOrgChartPopup"
                            v-if="!selectPopup"
                            >조직도
                          </el-button>
                          <el-button size="small" type="plus" @click="addMsngRcvGroupRcvrInfo"
                            v-if="!selectPopup"
                          >
                            <i class="icon-Plus" />
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <idc-list
                      :tableHeader="subHeader"
                      :tableData="subData"
                    >
                      <template #rcvrNm="{ scope }">
                        <el-input
                          size="small"
                          v-model="scope.row.rcvrNm"
                          :placeholder="$t('messages.plInput')"
                          :disabled="selectPopup"
                          @change="appendUpdateData(scope.row)"
                        />
                      </template>
                      <template #rcvrCntplc="{ scope }">
                        <el-input
                          size="small"
                          v-model="scope.row.rcvrCntplc"
                          :placeholder="$t('messages.plInput')"
                          :disabled="selectPopup"
                          @change="appendUpdateData(scope.row)"
                        />
                      </template>
                      <template #rcvrEmail="{ scope }">
                        <el-input
                          size="small"
                          v-model="scope.row.rcvrEmail"
                          :placeholder="$t('messages.plInput')"
                          :disabled="selectPopup"
                          @change="appendUpdateData(scope.row)"
                        />
                      </template>
                      <template #deleteBtn="{ scope }">
                        <el-button type="minus" @click="appendDeleteData(scope.row, scope.$index)"
                          :disabled="selectPopup"
                        >
                            <i class="icon-Minus" />
                          </el-button>
                      </template>
                    </idc-list>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
          <div slot="footer" class="ly-detail-footer" v-if="!selectPopup">
            <el-button type="save" v-if="formType==='modify'" @click="modifyMsngTmpltRcvGroup">
              {{ $t("messages.btnModify") }}
            </el-button>
            <!-- <el-button type="info">
              {{ $t("messages.btnDelete") }}
            </el-button> -->
            <el-button type="primary" v-else @click="createMsngTmpltRcvGroup">
              {{ $t("messages.btnRegist") }}
            </el-button>
          </div>
        </template>
        <template v-else>
          <idc-no-data :text="$t('messages.msgNodata')"
        /></template>
      </div>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcInput from "@/components/common/IdcInput.vue";
import IdcNoData from "@/components/common/IdcNoData.vue";
import IdcList from "@/components/common/IdcList";
import { copyObject } from "@/assets/js/common.js";

export default {
  mixins: [commonMixin],
  components: {
    IdcInput,
    IdcNoData,
    IdcList,
  },
  props: {
    selectPopup: {
      type: Boolean,
      default: false
    },
    rcvList:{
      type: Array,
      default: () => [],
    }
  },
  created() {
    this.$EventBus.$on("selectMsgGroupCd", this.selectMsgGroupCd);
    this.getTmpltTypeList();
  },
  beforeDestroy() {
    this.$EventBus.$off("selectMsgGroupCd");
  },
  computed: {
    currentMsngTmpltRcvGroup() {
      return this.$store.getters['msgGroupManageStore/getCurrentMsngTmpltRcvGroup'];
    },
    formType() {
      return this.formDataMsngTmpltRcvGroup.msngRcvGroupTmpltId? 'modify':'regist';
    },
    userNm() {
      if (this.formType === 'regist') {
        return this.$store.getters['userInfoStore/getLoginUserNm'];
      } else {
        return this.currentMsngTmpltRcvGroup.regrNm;
      }
    }
  },
  watch: {
    currentMsngTmpltRcvGroup(newData) {
      if (Object.keys(newData).length > 0) {
        this.isShowDetail = true;
      } else {
        this.isShowDetail = false;
      }
      this.initForm();
      if (this.formType === "modify") {
        this.getMsngRcvGroupRcvrInfoList();
      } else {
        this.subData = [];
      }
    },
    rcvList(){
      console.log(this.rcvList)
      if(this.rcvList.length > 0){
        const rcvList = this.rcvList.map(data=>{
          return {...data, msngRcvGroupTmpltId: this.currentMsngTmpltRcvGroup.msngRcvGroupTmpltId};
        });
        this.subData = this.subData.concat(rcvList);
      }
    }
  },
  data() {
    return {
      formDataMsngTmpltRcvGroup: {},
      isShowDetail: false,
      options1: [
        {
          label: "1",
          value: "1",
        },
      ],
      tmpltTypeList: [],
      options3: [
        {
          label: "사용",
          value: "Y",
        },
        {
          label: "미사용",
          value: "N",
        },
      ],
      subHeader: [
        {
          type: "selection",
        },
        {
          prop: "rcvrNm",
          label: "수신자명",
          width: "8",
          columnType: "custom",
        },
        {
          prop: "rcvrEmail",
          label: "이메일",
          width: "8",
          columnType: "custom",
        },
        {
          prop: "rcvrCntplc",
          label: "연락처",
          width: "13",
          columnType: "custom",
        },
        {
          prop: "deleteBtn",
          label: "",
          width: "2",
          columnType: "custom",
        },
      ],
      tableData2: [],
      inputList1: "",
      inputList2: "",
      inputList3: "",
      subData: [],
      updateList: {},
      insertList: []
    }
  },
  methods: {
    initForm() {
      this.formDataMsngTmpltRcvGroup = copyObject(this.currentMsngTmpltRcvGroup);
    },
    async getTmpltTypeList() {
      const { data } = await this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.getCdList, {upCd:3280});
      this.tmpltTypeList = data.resData;
    },
    async createMsngTmpltRcvGroup() {
      if (!confirm("저장하시겠습니까?")) return;
      console.log(this.formDataMsngTmpltRcvGroup);
      const { data } =await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.postMsngTmpltRcvGroup, this.formDataMsngTmpltRcvGroup);
      const insertList = this.subData.map(subData=>{
        return {
          ...subData,
          msngRcvGroupTmpltId: data.resData,
        }
      });
      await Promise.all(insertList.map(data=>this.createMsngRcvGroupRcvrInfo(data)));
      alert("저장되었습니다.");
      this.$emit("saveMsngTmpltRcvGroup");
    },
    async modifyMsngTmpltRcvGroup() {
      if (!confirm("수정하시겠습니까?")) return;
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.putMsngTmpltRcvGroup, this.formDataMsngTmpltRcvGroup);
      const insertList = this.subData.filter(data=>!data.msngRcvGroupRcvrInfoSeq);
      await Promise.all(insertList.map(data=>this.createMsngRcvGroupRcvrInfo(data)));
      const updateList = Object.values(this.updateList);
      await Promise.all(updateList.map(data=>this.putMsngRcvGroupRcvrInfo(data)));
      alert("수정되었습니다.");
      this.$emit("saveMsngTmpltRcvGroup");
      this.getMsngRcvGroupRcvrInfoList(this.currentMsngTmpltRcvGroup.msngRcvGroupTmpltId);
    },
    async createMsngRcvGroupRcvrInfo(data) {
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.postMsngRcvGroupRcvrInfo, data);
    },
    async putMsngRcvGroupRcvrInfo(data) {
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.putMsngRcvGroupRcvrInfo, data);
    },
    async getMsngRcvGroupRcvrInfoList() {
      const { data } = await this.$BIZ_SERVICE
        .post(this.$API_URLS.Opr.getMsngRcvGroupRcvrInfoList,
          {msngRcvGroupTmpltId: this.currentMsngTmpltRcvGroup.msngRcvGroupTmpltId,
            paging: false, delYn: 'N'});
      const { list } = JSON.parse(data.resData);
      this.subData = list;
    },
    addMsngRcvGroupRcvrInfo() {
      this.subData.push({rcvrNm: '', rcvrEmail: '', rcvrCntplc: '', delYn: 'N',
        msngRcvGroupTmpltId: this.currentMsngTmpltRcvGroup.msngRcvGroupTmpltId})
    },
    appendUpdateData(row) {
      this.updateList[row.msngRcvGroupRcvrInfoSeq] = row;
    },
    appendDeleteData(row, idx) {
      row.delYn = "Y"
      this.subData.splice(idx, 1);
      if (row.msngRcvGroupRcvrInfoSeq) {
        // 저장되있는 데이터인 경우
        this.updateList[row.msngRcvGroupRcvrInfoSeq] = row;
      }
    },
    expandDetailView() {
      this.onComponentDetailView();
      if (this.isToggle3) {
        this.$refs.box3.removeAttribute("style");
      } else {
        this.$refs.box3.setAttribute("style", "490px");
      }
      this.$emit("expandDetailView");
    },
    openTreePopup() {
      this.$store.commit('popupManageStore/setModalSelectMsgGroup', true);
    },
    selectMsgGroupCd(msgGroup) {
      this.formDataMsngTmpltRcvGroup.msngRcvCtgNm = msgGroup.cdHnglNm;
      this.formDataMsngTmpltRcvGroup.msngRcvCtgCd = msgGroup.cd;
    },
    openOrgChartPopup() {
      this.$emit('openOrgChartPopup');
    },
  }
}
</script>

<style>

</style>